import { useState } from "react"
import { DE, ES, GB, HU, CN } from "country-flag-icons/react/3x2"
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap"
import { useTranslation } from "react-i18next"
import styles from './LanguageSelector.module.scss'
import moment from 'moment'
import { getMomentLocale } from '../../../i18n'

const iconsByLocale = {
  en: <GB />,
  hu: <HU />,
  de: <DE />,
  es: <ES />,
  zh: <CN />,
}
export const LanguageSelector = () => {
  const { i18n } = useTranslation()

  const setLanguage = (newLanguage: string) => {
    if (i18n.language !== newLanguage) {
      i18n.changeLanguage(newLanguage)
      moment.locale(getMomentLocale(i18n.language))
      sessionStorage.setItem("LANG_OVERRIDE", newLanguage)
    }
  }

  const [dropdownOpen, setDropdownOpen] = useState(false)
  const toggle = () => setDropdownOpen((prevState) => !prevState)

  return (
    <>
      <Dropdown isOpen={dropdownOpen} toggle={toggle}>
        <DropdownToggle className={styles.button}>{iconsByLocale[i18n.language.slice(0, 2) as keyof typeof iconsByLocale]}</DropdownToggle>
        <DropdownMenu className={styles.menu}>
          {Object.keys(iconsByLocale).map((x) => (
            <DropdownItem key={x} onClick={() => setLanguage(x)} className={styles.item}>
              {iconsByLocale[x as keyof typeof iconsByLocale]}
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
    </>
  )
}